import React, { useEffect, useState } from 'react';
import ScreenShare from './ScreenShare';
import PanelUrlPicker from './PanelUrlPicker';
import RoomScreenShareDialog from './RoomScreenShareDialog';
import { useWorldStore } from '../stores/worldStore';
import { broadcastObjectUpdate } from '../services/worldBroadcast';

export function openMediaPanel(id: string, action: 'share' | 'url') {
  window.dispatchEvent(new CustomEvent('media-panel-use', { detail: { id, action } }));
}

/** Shared by the editor and viewer, outside Canvas so dialogs survive XR exit. */
export default function MediaPanelDialogs({ worldId, canConfigure }: { worldId: string; canConfigure?: boolean }) {
  return <>
    <PanelDialogs worldId={worldId} canConfigure={canConfigure} />
    <RoomScreenShareDialog isOwner={canConfigure ?? useWorldStore.getState().isOwner} />
  </>;
}

function PanelDialogs({ worldId, canConfigure }: { worldId: string; canConfigure?: boolean }) {
  const [target, setTarget] = useState<{ id: string; action: 'share' | 'url' } | null>(null);
  const item = useWorldStore(s => target ? s.screenProps[target.id] : undefined);
  const canBuild = useWorldStore(s => s.canBuild);
  useEffect(() => {
    const open = (event: Event) => setTarget((event as CustomEvent).detail);
    window.addEventListener('media-panel-use', open);
    return () => window.removeEventListener('media-panel-use', open);
  }, []);
  if (!target || !item) return null;
  if (target.action === 'share') return <ScreenShare onClose={() => setTarget(null)} />;
  if (!(canConfigure ?? canBuild)) return null;
  return <PanelUrlPicker key={target.id} editing initialUrl={item.browserUrl || ''} onClose={() => setTarget(null)} onPlace={browserUrl => {
    useWorldStore.getState().updateScreenProp(target.id, { browserUrl });
    broadcastObjectUpdate(worldId, 'screenprop', target.id, { browserUrl });
    setTarget(null);
  }} />;
}
